import { map, Observable } from 'rxjs';

// IMPORTANT Autogenerated file
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  CorrectiveMaintenanceDto,
  CorrectiveMaintenanceFitWidgetDto,
  CorrectiveMaintenanceIitWidgetDto,
  CountWidgetDto,
} from '@ellf/common-dto';
import { FilterValue, PagedResultDto } from '@ellf/common-interfaces';
import { CorrectiveMaintenanceViewEnum } from '@ellf/common-utils';
import { ApiClientConfig } from '../api-client-config';
import { BaseCRUDApiClient } from './baseCRUD.api-client';

@Injectable()
export class CorrectiveMaintenanceApiClient extends BaseCRUDApiClient<CorrectiveMaintenanceDto> {
  baseUrl = this.config.apiEndpoint + '/corrective-maintenance';

  constructor(http: HttpClient, config: ApiClientConfig) {
    super(http, config);
  }

  cancel(id: string, notes: string) {
    return this.http.put<CorrectiveMaintenanceDto>(
      `${this.baseUrl}/${id}/cancel`,
      { notes },
    );
  }

  getCountInPeriod(
    fromDate: string | undefined,
    toDate: string | undefined,
    filters: any,
  ) {
    return this.http.post<CountWidgetDto>(
      `${this.baseUrl}/get-count-in-period`,
      {
        fromDate,
        toDate,
        ...filters,
      },
    );
  }
  getOpenInPeriod(
    fromDate: string | undefined,
    toDate: string | undefined,
    filters: any,
  ) {
    return this.http.post<CountWidgetDto>(
      `${this.baseUrl}/get-open-in-period`,
      {
        fromDate,
        toDate,
        ...filters,
      },
    );
  }
  getCloseInPeriod(
    fromDate: string | undefined,
    toDate: string | undefined,
    filters: any,
  ) {
    return this.http.post<CountWidgetDto>(
      `${this.baseUrl}/get-close-in-period`,
      {
        fromDate,
        toDate,
        ...filters,
      },
    );
  }
  getIITInPeriod(
    fromDate: string | undefined,
    toDate: string | undefined,
    code: string | undefined,
    filters: any,
  ) {
    return this.http.post<CorrectiveMaintenanceIitWidgetDto>(
      `${this.baseUrl}/get-iit-in-period`,
      {
        fromDate,
        toDate,
        code,
        ...filters,
      },
    );
  }
  getFITInPeriod(
    fromDate: string | undefined,
    toDate: string | undefined,
    filters: any,
  ) {
    return this.http.post<CorrectiveMaintenanceFitWidgetDto>(
      `${this.baseUrl}/get-fit-in-period`,
      {
        fromDate,
        toDate,
        ...filters,
      },
    );
  }

  getPagedWithViewFlag(
    viewMode: CorrectiveMaintenanceViewEnum,
    take: number,
    skip: number,
    orderBy?: { [field: string]: 'asc' | 'desc' },
    filters?: FilterValue[],
    join?: string[],
  ) {
    const mappedFilters = this.mapFilters(filters);

    return this.http.post<PagedResultDto<CorrectiveMaintenanceDto>>(
      `${this.baseUrl}/pagedview/${viewMode}`,
      {
        skip,
        take,
        orderBy,
        filters: mappedFilters,
        join,
      },
    );
  }

  findAllFiltered(
    filters: FilterValue[],
    orderBy: { [field: string]: 'asc' | 'desc' },
    join?: string[],
    overwriteJoin?: boolean,
  ) {
    const mappedFilters = this.mapFilters(filters);

    return this.http.post<CorrectiveMaintenanceDto[]>(
      `${this.baseUrl}/find-all-filtered`,
      {
        filters: mappedFilters,
        orderBy,
        join,
        overwriteJoin,
      },
    );
  }

  synchDocumentWithGlobalService(documentId: string) {
    return this.http.get(
      `${this.baseUrl}/sync-document-with-coswin/${documentId}`,
    );
  }

  downloadMCDocumentsModelExcel(fileName?: string): Observable<ArrayBuffer> {
    return this.http
      .post(
        this.baseUrl + '/download-mc-documents-model-excel',
        { fileName },
        {
          responseType: 'arraybuffer',
        },
      )
      .pipe(
        map((file: ArrayBuffer) => {
          return file;
        }),
      );
  }

  uploadMCDocumentsFromExcel(list: FileList) {
    const files = Array.from(list);
    const fd = new FormData();
    files.forEach((file) => fd.append('files', file));
    return this.http.post<
      { errors: { error: string; row: number | undefined }[] }[]
    >(this.baseUrl + '/upload-mc-documents-from-excel', fd);
  }
}
